import {apolloClient} from '@/setup/apollo-setup';
import {error, newItemSuccess, updateItemSuccess} from '@/utils/notification';
import {
  GET_STUDENTTOPICLEARN,
  GET_STUDENTTOPICLEARNS,
  GET_STUDENTTOPICLEARNS_BY_FILTER,
  ADD_STUDENTTOPICLEARN,
  UPDATE_STUDENTTOPICLEARN,
} from '@/queries/modules/student-unit-learn/student-topic-learn.js';

export async function getStudentTopicLearns(context) {

  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_STUDENTTOPICLEARNS,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });
    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setStudentTopicLearns', data.getStudentTopicLearns);
      context.commit('setSuccess', null);
      return data.getStudentTopicLearns
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getStudentTopicLearnsByFilter(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_STUDENTTOPICLEARNS_BY_FILTER,
        variables: payload,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setStudentTopicLearns', data.getStudentTopicLearnsByFilter);
      context.commit('setSuccess', null);

      return data.getStudentTopicLearnsByFilter;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getStudentTopicLearn(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_STUDENTTOPICLEARN,
        variables: payload,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setStudentTopicLearn', data.getStudentTopicLearn);
      context.commit('setSuccess', null);
      return data.getStudentTopicLearn
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function addStudentTopicLearn(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: ADD_STUDENTTOPICLEARN,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const studentTopicLearns = [...context.state.studentTopicLearns];
      studentTopicLearns.push(data.addStudentTopicLearn);
      context.commit('setStudentTopicLearns', studentTopicLearns);
      context.commit('setSuccess', newItemSuccess(data.addStudentTopicLearn.id));

      return data.addStudentTopicLearn;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function updateStudentTopicLearn(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: UPDATE_STUDENTTOPICLEARN,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {

      const index = context.state.studentTopicLearns.findIndex(item => item.id === data.updateStudentTopicLearn.id);
      const studentTopicLearns = [
        ...context.state.studentTopicLearns.slice(0, index),
        data.updateStudentTopicLearn,
        ...context.state.studentTopicLearns.slice(index + 1)
      ];
      context.commit('setStudentTopicLearns', studentTopicLearns);
      context.commit('setSuccess', updateItemSuccess(data.updateStudentTopicLearn.id));

      return data.updateStudentTopicLearn
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}
